import React from "react";

const WalletTrue = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M30.041 2.968a.97.97 0 00-1.178-.945L6.279 7.047h23.765l-.003-4.079zM25.049 18.746l-6.54-2.945a.97.97 0 00-.798 0l-6.486 2.92a.972.972 0 00-.628.908v5.278c0 2.088.61 4.14 2.342 5.444l4.574 3.442a.973.973 0 001.185.011l4.585-3.453c1.731-1.305 2.34-3.356 2.34-5.442l-.002-5.28a.97.97 0 00-.572-.883zm-2.628 4.127l-3.945 3.94a.971.971 0 01-1.375 0l-1.888-1.886a.97.97 0 010-1.373.974.974 0 011.375 0l1.2 1.198 3.258-3.252a.974.974 0 011.376 0 .97.97 0 010 1.373zM31.056 19.862c0 1.277.943 2.347 2.166 2.553v-5.107a2.604 2.604 0 00-2.166 2.554z"
            fill={fill}
        />
        <path
            className="u_fill"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M32.248 8.99H3.974A.972.972 0 003 9.96v19.8c0 .537.436.972.973.972h6.57a7.562 7.562 0 01-1.135-1.862c-.537-1.248-.756-2.61-.756-3.965v-5.278c0-.606.193-1.176.522-1.65.31-.45.745-.808 1.254-1.026l6.486-2.92c.392-.177.8-.26 1.196-.26.41 0 .82.09 1.198.26l6.54 2.945c.522.235.945.616 1.244 1.078.303.468.468 1.015.468 1.574l.01 5.279c0 1.35-.22 2.708-.756 3.955a7.626 7.626 0 01-1.137 1.87h6.572a.972.972 0 00.972-.971v-5.39c-2.3-.216-4.111-2.16-4.111-4.51 0-2.351 1.812-4.295 4.111-4.512V9.96a.972.972 0 00-.972-.97z"
            fill={fill}
        />
    </svg>
);

export default WalletTrue;
